import { useEffect, useMemo } from 'react';
import dayjs from 'dayjs';

import { RAW_DATE_FORMAT } from '@/common/constants';
import { API_URL } from '@/dtos';

import { useBaseReportTableQuery } from '../../queries';
import { PrefundInvoiceReportTableParams } from '../PrefundReport.types';

export const QUERY_KEY = 'PREFUND_INVOICE_REPORT_QUERY';

const MIN_SEARCH_LEN = 3;
const usePrefundInvoiceReportQuery = (params: Partial<PrefundInvoiceReportTableParams>) => {
  const currentSearch = useMemo(() => {
    if (!!params?.searchString && params?.searchString?.length >= MIN_SEARCH_LEN) {
      return params.searchString;
    }
    return null;
  }, [params.searchString]);

  const formattedStartDate = useMemo(() => {
    if (!params.startDate) {
      return null;
    }
    const parsedDate = dayjs(params.startDate);
    if (!parsedDate.isValid()) {
      return null;
    }
    return parsedDate.format(RAW_DATE_FORMAT);
  }, [params.startDate]);

  const formattedEndDate = useMemo(() => {
    if (!params.endDate) {
      return null;
    }
    const parsedDate = dayjs(params.endDate);
    if (!parsedDate.isValid()) {
      return null;
    }
    return parsedDate.format(RAW_DATE_FORMAT);
  }, [params.endDate]);
  const base = useBaseReportTableQuery(
    API_URL.REPORTS_PREFUND_INVOICE_REPORT_BREAKDOWN,
    [QUERY_KEY, currentSearch, params.employerId, params?.invoiceID, params.startDate, params.endDate],
    {
      employer_id: params.employerId,
      show_ssn: true,
      invoice_close_start_date: formattedStartDate,
      invoice_close_end_date: formattedEndDate,
      invoice_id: params.invoiceID,
      isSSNShowed: params.isSSNShowed,
      search_value: currentSearch,
    },
    {
      isPreviewMode: params.isPreviewMode,
    }
  );

  useEffect(() => {
    base.onChangePlanOptions([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.employerId]);

  useEffect(() => {
    base.setPage(0);
    base.setRawContentList([]);
    base.setRawHeaders([]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.employerId, params?.searchString, params?.startDate, params?.endDate, params?.invoiceID]);
  return base;
};

export default usePrefundInvoiceReportQuery;
